/**
 * Resolve the contract detail route for a row in a ContractList. When the sales line behind the
 * contract has has_dynamic_detail = true (exposed on the row as `has_dynamic_detail`), navigate
 * to the new dynamic detail; otherwise fall back to the current path (the legacy detail under
 * `$route.path + '/' + item.id`).
 *
 * Used both by per-flavour lists (kam/pv/ice_peak/gadget) that inline a router-link, and by
 * OrticTable's built-in edit button via the `editRoute` prop.
 *
 * Usage in a Vue list page:
 *   import { dynamicContractRoute } from '~/utils/dynamicContractRoute'
 *   // template:
 *   <router-link :to="dynamicContractRoute(this, props.item)">…</router-link>
 *   // or OrticTable:
 *   <o-table :edit-route="item => dynamicContractRoute(this, item)" .../>
 */
export function dynamicContractRoute(vm, item) {
  if (item && item.has_dynamic_detail) {
    return { path: `/sandoz/dyn/contracts/${item.id}` }
  }
  return { path: `${vm.$route.path}/${item.id}` }
}
